const appButtons = document.querySelectorAll('.app-button');
const appModal = document.querySelector('.appPopup');
const modalOverlay = document.querySelector('.appPopup .modalOverlay');
const closeButton = document.querySelector('.appPopup .btnClose')
appButtons.forEach(button => {
    button.addEventListener('click', () => {
        appModal.classList.add('active');
        document.body.classList.add('noScroll');
    });
});

modalOverlay.addEventListener('click', () => {
    appModal.classList.remove('active');
    document.body.classList.remove('noScroll');
});

closeButton.addEventListener('click', () => {
    appModal.classList.remove('active');
    document.body.classList.remove('noScroll');
})
